import { Component } from '@angular/core';
import { Subscription } from 'rxjs';

import { ToasterService } from '../../services/toaster.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html'
})
export class ToasterComponent {
  private toast_subscription!: Subscription;

  constructor(
    private toasterService: ToasterService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    // Subscribe to the toast messages
    this.toast_subscription = this.toasterService.getToast().subscribe((message) => {
      this.showToast(message);
    });
  }

  ngOnDestroy() {
    // Unsubscribe from the toast messages when the component is destroyed
    this.toast_subscription.unsubscribe();
  }

  showToast(message: any) {
    this.messageService.clear();
    this.messageService.add(message);
  }
}
